import React from "react";
import PropTypes from "prop-types";
import styles from "./StatusIcon.module.css";
import { FaCheck, FaExclamationCircle } from "react-icons/fa";
import { ReactComponent as XmarkIcon } from "./xmark-solid.svg";

/**
 * View component. Shows the status of a user's group.
 */

export function StatusIcon({ status }) {
  return (
    <div className={styles.container}>
      {status === "yes" ? (
        <FaCheck className={styles.checkmarkIcon} />
      ) : status === "no" ? (
        <XmarkIcon className={styles.xmarkIcon} />
      ) : status === "important" ? (
        <FaExclamationCircle className={styles.exclamationIcon} />
      ) : (
        <></>
      )}
    </div>
  );
}

StatusIcon.propTypes = {
  /**
   * Status of "yes” shows green check, status of “no” shows red X,
   * status of “important” shows exclamation mark
   */
  status: PropTypes.oneOf(["yes", "no", "important"]),
};
